import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { size, map } from 'lodash';

// import { Link } from 'react-router-dom';
import {
  Container,
  Row,
  Col,
  Button
} from 'reactstrap';
import Panel from '../../containers/Panel';
import Loading from '../helpers/Loading';
// import PixelSetForm from './form';
import PixelsIcons from './pixelsIcons';

import ModalLink from '../modals/ModalLink';

import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { listPixelSets, addPixelSetSuccess, deletePixelSetSuccess, deletePixelSet } from '../../actions';
import { modalOpen } from '../../actions/modals';
import { PixelSet } from '../../api'

const mapStateToProps = state => ({ pixelSets: state.pixelSets, isLoading: state.loaders.pixelSets });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({listPixelSets, addPixelSetSuccess, deletePixelSetSuccess, deletePixelSet, modalOpen}, dispatch)
};




class PixelSetItem extends Component {
  
  constructor(props) {
    super(props);
    this.deletePixelSet = this.deletePixelSet.bind(this);
    this.editPixelSet = this.editPixelSet.bind(this);
    this.state = {
      ...this.state,
      isDeleting: false
    };
  }
  
  editPixelSet(e) {
    if (e && e.preventDefault)
      e.preventDefault();
    
    const { modalOpen, pixelSet } = this.props;
    
    modalOpen('editPixelSet', {pixelId: pixelSet.id});
  }
  
  deletePixelSet(e) {
    if (e && e.preventDefault)
      e.preventDefault();
    
    if (!window.confirm("Do you really want to delete this pixel set?")){
      return;
    } 
    
    const { pixelSet, deletePixelSetSuccess } = this.props;
    const stopLoading = () => this.setState({isDeleting:false});
    
    this.setState({isDeleting:true});
    PixelSet.destroy({id:pixelSet.id}).then(deletePixelSetSuccess).then(stopLoading, stopLoading)
  }
  
  
  render() {
    const { pixelSet } = this.props;
    return (
      <div className="pixel-set">
        <Button onClick={this.deletePixelSet} color="link" className="float-right" disabled={this.state.isDeleting}>&times;</Button>
        <div className="pixel-set-name">{ pixelSet.name }</div>
        <div className="pixel-set-pixels"><PixelsIcons pixels={ pixelSet.pixels } /></div>
        <ModalLink to="editPixelSet" params={{pixelId: pixelSet.id}}>edit</ModalLink>
        <hr />
      </div>
    )
  }
}


class PixelSetsList extends Component {
  render() {
    const { pixelSets, isLoading, ...rest } = this.props;
    
    if (size(pixelSets) <= 0 && isLoading === true)
      return (<Loading text="Loading your pixels..." />);
    else{
      const pixelSetsList = map(pixelSets, (pixelSet,idx) => (
        <CSSTransition
            key={pixelSet.id}
            timeout={1000}
            classNames="fade-item"
          >
          <PixelSetItem pixelSet={pixelSet} {...rest} />
        </CSSTransition>
      ));
      
      return (
        <TransitionGroup className="pixels-list">
          {pixelSetsList}
        </TransitionGroup>
      );
    }
  }
}



class PixelSets extends Component {
  componentWillMount(nextProps) {
    this.props.listPixelSets();
  }
  
  reload(e){
    e.preventDefault();
    this.props.listPixelSets();
  }
  
  render() {
    return (
      <Container>
        <Row>
          <Col>
            <ModalLink to="newPixelSet" className="btn btn-success btn-sm float-right">Add New Pixel Set</ModalLink>
            <h1>Your Pixels</h1>
            
            <Panel>
              <PixelSetsList {...this.props} />
            </Panel>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(PixelSets);


// WEBPACK FOOTER //
// ./src/components/PixelSets/index.js